{
  "en": {
    "backofficeHeader": {
      "exit": "Leave Backoffice"
    }
  }
}
